export class PenStanchionDto {
  public static ApiUrl = 'api/pen-stanchion';

  Id: number;
  Type: string;
  Height: number;
  Name: string;
  NameEn: string;
  NameEs: string;
}
